import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DomainType} from '../../../generate/TopLevelDomainVO';

@Component({
  selector: 'domain-type',
  templateUrl: './domain-type.component.html',
  styleUrls: ['./domain-type.component.scss']
})
export class DomainTypeComponent implements OnInit {

  editDomainTypeForm: FormGroup;

  @Input()
  domainType: DomainType;

  @Input()
  isCreatingDomain: boolean;

  @Input()
  domainName: string;

  @Output()
  domainTypeOutput = new EventEmitter<DomainType>();

  @Output()
  cancelOutPut = new EventEmitter<boolean>();

  constructor(private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.createForm();
  }

  onSubmit() {
    let newDomainType = this.editDomainTypeForm.value.domainType;

    if (this.isCreatingDomain) {
      this.domainTypeOutput.emit(newDomainType);
    } else {
      this.domainTypeOutput.emit(this.domainType);
    }


  }

  cancel() {
    this.cancelOutPut.emit(true);
  }

  isFormInValid(): boolean {
    if (!this.isCreatingDomain) {
      return false;
    } else {
      return !this.editDomainTypeForm.valid;
    }
  }

  private createForm() {

    this.editDomainTypeForm = this.formBuilder.group({
      domainType: [this.domainType == null ? null : this.domainType, [Validators.required]]
    });
  }

  getDomainTypeValue(type: number): string {
    let domainType: DomainType;
    switch (type) {
      case 0:
        domainType = "GENERIC";
        break;
      case 1:
        domainType = "COUNTRY_CODE";
        break;
    }

    return domainType.toString();
  }

  getDomainType(): string {
    if (this.domainType) {
      return this.domainType.toString().replace("_", " ");
    }
  }

  getDomainTypeDisplayValue(type: number) {
    return this.getDomainTypeValue(type).replace("_", " ");
  }

}
